export enum ChatWidgetPosition {
    Custom = 1,
    BottomRight = 2,
    BottomLeft = 3,
    TopRight = 4,
    TopLeft = 5,
}
